import * as yup from 'yup';
export const optOutSchema = yup
    .object()
    .camelCase()
    .shape({
    id: yup.string().required().ensure(),
    patientId: yup.number().defined(),
    cptCodeId: yup.number().defined(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
});
